export default function ArtPlaceholder({ emoji = "🎨" }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minHeight: 180,
        background: "linear-gradient(135deg, #ede3d3, #e0d2bc)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "3rem",
        opacity: 0.45,
      }}
    >
      {emoji}
    </div>
  );
}
